import React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';

import routes from '../../../common/constants/routes'
import {buttonStyle} from '../../../common/constants/buttonStyle';
import {useCartContext} from '../../../context/CartContext';
import CCOLink from '../../fundamentals/CCOLink'
import {usePageContext} from "../../../context/PageContext";
import {ADDITIONAL_OFFSET_LARGE_SCREEN, INITIAL_OFFSET_CART} from "../../fundamentals/CCOCartFab";
import CCOPicture from "../../fundamentals/CCOPicture";
import {toCommaSeparatedDecimal} from "../../../utility/componentUtil";
import {getRouteUrl} from "../../../utility/navigationUtil";
import {metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";

interface Props {
    open?: boolean;
    item?: any;
}

function C056QueryListCartNotification(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const pageContext = usePageContext();
    const cartLink = getRouteUrl(pageContext.rootUrl, routes.PUBLICATIONS.CART)
    const {t} = useTranslation();
    const cartContext = useCartContext();
    const isStorybook = typeof window !== "undefined" && (window as any).__STORYBOOK_CLIENT_API__;
    const cartUrl = getRouteUrl(pageContext.rootUrl, routes.PUBLICATIONS.CART)

    const currentItem = isStorybook ? null : cartContext.getLatestAddedItem();

    return (
        <CCOLink tabIndex={-1} target={cartUrl}>
            <Snackbar
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                autoHideDuration={3}
                open={props.open}
                sx={cartNotificationSnackbarStyle}
            >
                <Card>
                    <CardContent>
                        <Typography
                            sx={{
                                textAlign: 'center',
                                fontWeight: 'bold'
                            }}>
                            {t("cart.added_to_cart_message")}:
                        </Typography>
                        <Grid container spacing={0} sx={{
                            margin: 2,
                            width: 'calc(100% + 8px)',
                            '& > .MuiGrid-root': {
                                paddingTop: '8px',
                                paddingLeft: '8px'
                            }
                        }}>
                            <Grid size={{xs: 4}}>
                                <CCOPicture
                                    sxImage={{width: 100}}
                                    name={currentItem?.sosPublication.picture?.name}
                                    picture={currentItem?.sosPublication.picture}
                                    orientation={'portrait_ratio3x4'} width={'780'}
                                    height={'1040'}/>
                            </Grid>
                            <Grid size={{xs: 8}} sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}>
                                <Typography
                                    {...metaDataProperty(isPreview,
                                        'properties.title',
                                        currentItem?.sosPublication.id)}
                                    variant={'subtitle1'}
                                    sx={{
                                        fontWeight: 'bold'
                                    }}>{currentItem?.sosPublication.title}</Typography>
                                <Typography
                                    {...metaDataProperty(isPreview,
                                        'properties.price',
                                        currentItem?.sosPublication.id)}
                                    variant={'subtitle1'}>{`${t(
                                    "cart.item_price")}: ${toCommaSeparatedDecimal(
                                    currentItem?.price ?? 0)} €`}</Typography>
                            </Grid>
                        </Grid>
                        <Grid size={{xs: 12}} sx={{display: 'flex', justifyContent: 'center'}}>
                            <Button variant="contained" sx={{...buttonStyle.green, marginTop: 3}}
                                    component={'div'} href={cartLink}>
                                {t("cart.go_to_cart")}
                            </Button>
                        </Grid>
                    </CardContent>
                </Card>
            </Snackbar>
        </CCOLink>
    );
}

const cartNotificationSnackbarStyle = {
    position: 'fixed',
    top: {
        xs: INITIAL_OFFSET_CART,
        lg: INITIAL_OFFSET_CART + ADDITIONAL_OFFSET_LARGE_SCREEN + 40
    },
}

export function handleNotificationOpen(setNotificationCardOpen: any) {
    setNotificationCardOpen(true);
    return setTimeout(() => {
        setNotificationCardOpen(false);
    }, 3000);
}

export default C056QueryListCartNotification
